<ng-container>
  <pr-input-radio
    formControlName="avSouscriptionGarantiePlancher"
    direction="column"
    [isDefault]="false"
    [toggle]="true"
    [defaultValue]="true"
    columns="5"
  >
  </pr-input-radio>

  <info [option]="{ icon: 'info' }"
    >La garantie plancher est une option qui garantit au souscripteur d'un
    contrat
    {{ isPer ? "plan d'épargne retraite individuel" : "d'assurance vie" }} en
    unité de compte que ses bénéficiaires désignés toucheront au minimum le
    capital investi.</info
  >
</ng-container>
